module.exports = __webpack_public_path__ + "static/media/reporting.577a75d3.svg";